import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CreateTextDialogProps {
  open: boolean;
  dialogTitle?: string;
  onClose: () => void;
  onCreate: (title: string) => Promise<void>;
}

// TODO: Create associated Scene
export function CreateTextDialog({ open, dialogTitle, onClose, onCreate }: CreateTextDialogProps) {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleCreate = async () => {
    if (!title.trim()) return;
    setIsCreating(true);
    try {
      await onCreate(title.trim());
      setTitle('');
      onClose();
    } catch (error) {
      console.error('Failed to create text:', error);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !isCreating && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{dialogTitle || t('editor.create_new_scene')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={t('editor.title')}
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          disabled={isCreating}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleCreate();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isCreating}>
          {t('editor.cancel')}
        </Button>
        <Button onClick={handleCreate} variant="contained" disabled={!title.trim() || isCreating}>
          {t('editor.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
